import React, { useState, useEffect, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
import MobileTelecom from '../../../../components/box/MobileTelecom';
import style from './FindPassword.module.css';
import URL, { DPMSG_APIKEY } from '../../../../constants/url';
import axiosApi from '../../../../api/daonAxios';
import { useLocation, useNavigate } from 'react-router-dom';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import { getIsDpAuthUserId, setDpResetPasswordUid } from '../../../../assets/js/comm';
import CODE from '../../../../constants/code';


const FindPassword = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location; //

    //console.log(" ============> FindPassword state ", state);

    const AFTCR_FIND_ID = "AFTCR_FIND_ID";

    const [step, setStep] = useState(1);
    const [pwStep, setPwStep] = useState(1);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [open, setOpen] = useState(false);

    // 아이디 입력
    const userIdRef = useRef('');
    const [userId, setUserId] = useState('');
    const [name, setName] = useState('');
    const [telecom, setTelecom] = useState('');
    const [phone, setPhone] = useState('');
    const [verificationCode, setVerificationCode] = useState('');

    const [timeLeft, setTimeLeft] = useState(180); // 3분 = 180초
    const [isTimeout, setIsTimeout] = useState(false);

    const [password, setPassword] = useState('');
    const [pwRules, setPwRules] = useState({
        lengthAt: false,
        numberAt: false,
        letterAt: false,
        // letterUpperAt: false,
        specialAt: false,
    });

    const [rePassword, setRePassword] = useState('');
    const [pwLineStatus, setPwLineStatus] = useState("");      // 비밀번호 line
    const [rePwLineStatus, setRePwLineStatus] = useState("");  // 재입력 line

    const onDismiss = () => setOpen(false);

    const onTelecomSelect = (selectedTelecom) => {
        setTelecom(selectedTelecom);
        setOpen(false);
    };

    // 비밀번호 line 상태 계산
    useEffect(() => {
        if (!password) {
            setPwLineStatus(""); // 비어있으면 표시 없음
        } else {
            setPwLineStatus(Object.values(pwRules).every(Boolean) ? "off" : "on");
        }
    }, [password, pwRules]);

    // 재입력 비밀번호 line 상태 계산
    useEffect(() => {
        if (!rePassword) {
            setRePwLineStatus(""); // 비어있으면 표시 없음
        } else {
            setRePwLineStatus(
                password === rePassword ? "off" : "on"
            );
        }
    }, [password, rePassword, pwRules]);


    useEffect(() => {
        if (step === 5 && timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else if (timeLeft === 0) {
            setIsTimeout(true);
        }
    }, [timeLeft, step]);

    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    const handleNext = () => {

        //console.log(" ==========> userIdRef.current.length : ", userIdRef.current.value.length);

        if (step === 1 && userIdRef.current.value.length > 0) {
            getIsDpAuthUserId(userIdRef.current.value)
                .then((res) => {
                    //console.log("  ====> handleOnConfirm getIsDpAuthUserId res : ", res);
                    if (res) {
                        sessionStorage.setItem(AFTCR_FIND_ID, userIdRef.current.value);
                        // 아이디가 존재하는 경우, 다음스텝 진행
                        setStep(2);
                    } else {
                        setToastMessage("해당 아이디에 대한 가입 정보가 없습니다");
                        setToast(true);
                        return false;
                    }
                })
                .catch((err) => {
                    console.log(" ====> handleOnConfirm getIsDpAuthUserId error : ", err);
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                })
        } else if (step === 2) {
            // 통일성 있게 패스인증으로 넘김..
            navigate(URL.IDENTITY, { state: { moveToMenu: "findPw" } });
        } else if (step === 4 && phone.length >= 10) {
            setTimeLeft(180);
            setIsTimeout(false);
            setStep(5);
        } else if (step === 5) { // dp 인증방식 ... step 2 에서 패스인증 도입으로 사용하지 않음..
            setStep(6);
            // if (verificationCode === '1234') {
            // setStep(6);
            // } else {
            // setToast(true);
            // }
            // step 6 부터는 패스워드 로직으로 들어감.
        } else if ( step === 7 ) {
            handleOnBack();
        }
        /*
        else if (step < 5) {
            setStep(step + 1);
        }
        */
    };

    const handleOnBack = () => {
        navigate(URL.LOGINMAIN, {
            replace: true,
            state: { refreshAt: false }
        });
    };

    /**
     * 인풋박스 텍스트 변경 이벤트 처리
     * @param e
     */
    const handleOnChangeInput = (e) => {

        const inputName = e.target.name;
        //console.log( " ======> input event : ", e.target.name );
        if( inputName === "userId" ) {
            const inputUserId = userIdRef.current;
            if( inputUserId ) {
                // 영문, 숫자만 허용하는 정규식 // 아이디는 가져온다는 전제하에 정규식 체크 생략..
                // inputUserId.value = inputUserId.value.replace(/[^A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]|\s/g, '').trim();
                //console.log( " ========> inputUserId.value : ", inputUserId.value ); // 체킹용도~!
                setUserId(inputUserId.value)
            }
        }
        if( ["pswd", "rePswd"].includes(inputName) ) {
            // 정규식 check
            const regexPw = e.target.value.replace(/[^a-zA-Z0-9~!@#$%^&*()_+|<>?:{}[\]\\;'",./`-]/g, "");

            const lengthAt = regexPw.length >= 9;
            const numberAt = /\d/.test(regexPw);
            const letterAt = /[a-zA-Z]/.test(regexPw);
            // const letterUpperAt = /[A-Z]/.test(regexPw);
            const specialAt = /[!@#$%^&*(),.?":{}|<>]/.test(regexPw);

            setPwRules({ lengthAt, numberAt, letterAt, specialAt }); //letterUpperAt

            if( inputName === "pswd") {
                setPassword(regexPw.trim());
            } else {
                setRePassword(regexPw.trim());
            }
        }
    };

    const handlePw = () => {
        if (pwStep < 2) {

            setPwStep(pwStep + 1);
        } else if (pwStep === 2) {

            if( password === rePassword ) {
                if( state?.usrUid !== undefined && state?.usrUid !== "" ) {

                    // dp 로직+
                    const requestDpAuthStrUrl = "/signup/requestDpAuthString";

                    axiosApi.get(requestDpAuthStrUrl)
                        .then( async (res) => {

                            if(res.data.resultCode === CODE.RCV_SUCCESS) {
                                const authStr = res.data.result?.dpAuthStr;

                                await setDpResetPasswordUid(state?.usrUid, authStr, rePassword)
                                    .then( async (res) => {

                                        if(res.data === "success") {
                                            const requestChangePasswordUrl = "/signup/actionChangePassword"

                                            const requestParams = {
                                                encptCidVal: state?.encptCidVal
                                                , usrUid: state?.usrUid
                                                , usrId: state?.usrId
                                                , usrPswd: rePassword
                                            }

                                            const requestOptions = {
                                                headers: {
                                                    'authorization': DPMSG_APIKEY
                                                },
                                                noLoading: true
                                            }

                                            await axiosApi.post(requestChangePasswordUrl, requestParams, requestOptions)
                                                .then( (res) => {
                                                    sessionStorage.setItem(AFTCR_FIND_ID, ""); // 이 단계에서는 지워져도 상관없음
                                                    if(res.data.resultCode === CODE.RCV_SUCCESS) {
                                                        // 비밀번호 변경 성공.. // 결과값은 따로 체크할 필욘 없을듯...
                                                        setToastMessage('비밀번호가 변경 되었습니다');
                                                        setToast(true);
                                                        // 토스트가 보이도록 2초 후 페이지 이동
                                                        setTimeout(() => {
                                                            handleOnBack();
                                                        }, 2000);
                                                        //handleOnBack();
                                                    } else {
                                                        // 백엔드 서버가 문제있지 않는한.. 이쪽으로 떨어질 일이 없음
                                                        setToastMessage('비밀번호 재설정이 실패하였습니다. 다시 시도해 주세요.');
                                                        setToast(true);
                                                        return false;
                                                    }
                                                })
                                                .catch( err => {
                                                    console.log( " ================> setDpResetPasswordUid api error: ", err );
                                                    sessionStorage.setItem(AFTCR_FIND_ID, "");
                                                    setToastMessage('비밀번호 변경시 오류가 발생하였습니다(L2). 로그인 화면으로 이동합니다.');
                                                    setToast(true);
                                                    handleOnBack();
                                                })
                                        }
                                    })
                                    .catch( err => {
                                        console.log("=========> setDpResetPasswordUid func error : ", err);
                                        sessionStorage.setItem(AFTCR_FIND_ID, "");
                                        setToastMessage('비밀번호 변경시 오류가 발생하였습니다(D). 로그인 화면으로 이동합니다.');
                                        setToast(true);
                                        handleOnBack();
                                    })
                            }
                        })
                        .catch(err => {
                            console.log("=========> requestDpAuthString api error : ", err);
                            sessionStorage.setItem(AFTCR_FIND_ID, "");
                            setToastMessage('비밀번호 변경시 오류가 발생하였습니다(L1). 로그인 화면으로 이동합니다.');
                            setToast(true);
                            handleOnBack();
                        })

                } else {
                    // 이쪽으로 들어오게 되면, 100% 개발모드에서..step 값 조작임..
                    setToastMessage('시스템 조작이 의심되어 메인화면으로 이동합니다.');
                    setToast(true);
                    handleOnBack();
                }
            } else {
                setToastMessage('비밀번호를 다시 확인해 주세요');
                setToast(true);
            }
        }
    };

    useEffect(() => {
        if (step === 4 && verificationCode.length > 0) {
            setStep(5); // 인증번호 입력 시 자동으로 인증번호 입력란 노출
        }
    }, [verificationCode, step]);


    /**
     * pass 인증시 계정체크~! 잘못된 정보 튕겨내기
     */
    useEffect(() => {

        if(state?.usrId !== undefined) {
            const findId = sessionStorage.getItem(AFTCR_FIND_ID);
            if(state?.usrId === findId) {
                setStep(6);
            } else { // 정보가 서로 다를경우..
                sessionStorage.setItem(AFTCR_FIND_ID, "");
                setToastMessage("입력한 아이디와 본인인증 정보가 다릅니다. 다시 확인해주십시오.");
                setToast(true);
                setStep(1);
            }
        }
    }, [state?.usrId]);


     // password view
    const [pwView, setPwView] = useState(false);
    const [rePwView, setRePwView] = useState(false);

    const handlePwView = () => {
        setPwView(!pwView);
    }
    const handleRePwView = () => {
        setRePwView(!rePwView);
    }

    const handleRePasswordChange = (e) => {
        setRePassword(e.target.value);
    };

    return (
        <>
            <HeadSub title="비밀번호 찾기" onBack={handleOnBack} />

                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">

                        {step < 6 && (
                            <div className={style['content-box']}>
                                <strong className={style['title']}>
                                    {step === 2 ? '이름을 입력해주세요'
                                    : step === 3 ? '통신사를 선택해주세요'
                                    : step === 4 ? '휴대폰 번호를 입력해 주세요'
                                    : step === 5 ? '인증번호를 입력해 주세요 '
                                    : '아이디를 입력해 주세요'
                                }
                                </strong>

                                {step >= 5 && (
                                <div className={style['input-wrap']}>
                                        <div className='animation-2'>
                                        <span className={style['input-tit']}>인증번호</span>
                                        <div className={style['input-box']}>
                                            <input
                                                type="number"
                                                placeholder="인증번호를 입력해주세요"
                                                value={verificationCode}
                                                onChange={(e) => setVerificationCode(e.target.value)}
                                            />
                                            <span className={style['line']}></span>
                                            <button className={style['cancel-btn']} onClick={() => setVerificationCode('')}></button>
                                        </div>
                                        <div className={style['input-bottom']}>
                                            <span className={style['time']}>
                                                {isTimeout ? '인증시간 초과' : formatTime(timeLeft)}
                                            </span>
                                            <button
                                                className={style['request-btn']}
                                                disabled={!isTimeout}
                                                onClick={() => {
                                                    setTimeLeft(180); // 타이머 초기화
                                                    setIsTimeout(false);
                                                    setVerificationCode('');
                                                }}

                                            >
                                                <span>인증번호 재요청</span>
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                )}

                                {step >= 4 && (
                                    <div className={style['input-wrap']}>
                                        <div className='animation-2'>
                                        <span className={style['input-tit']}>휴대폰 번호</span>
                                        <div className={style['input-box']}>
                                            <input
                                                type="number"
                                                placeholder="휴대폰 번호를 입력해주세요"
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        </div>
                                    </div>
                                )}

                                {step >= 3 && (
                                    <div className={style['input-wrap']}>
                                        <div className='animation-2'>
                                        <span className={style['input-tit']}>통신사</span>
                                        <div className={style['input-box']} data-type-input="btn">
                                            <input
                                                type="button"
                                                placeholder={telecom || '통신사 선택'}
                                                className={style['telecom-input']}
                                                onClick={() => setOpen(true)}
                                                value={telecom}
                                                readOnly
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        </div>
                                    </div>
                                )}

                                {step >= 2 && (
                                <div className={style['input-wrap']}>
                                    <div className='animation-2'>
                                        <span className={style['input-tit']}>이름</span>
                                        <div className={style['input-box']}>
                                            <input
                                                type="text"
                                                placeholder='이름 입력'
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                    </div>
                                </div>
                                )}

                                {step >= 1 && (
                                <div className={style['input-wrap']}>
                                    <div className='animation-2'>
                                        <span className={style['input-tit']}>아이디</span>
                                        <div className={style['input-box']}>
                                            <input type="text" name="userId" placeholder='아이디 입력'
                                                   ref={userIdRef}
                                                   onChange={handleOnChangeInput}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                    </div>
                                </div>
                                )}

                            </div>
                        )}

                        {/* 새 비밀번호 입력 화면:: S */}
                        {step === 6 && (
                        <div className={style['content-box']}>
                            <strong className={style['title']}>새 비밀번호를 설정해주세요</strong>


                            {/* 비밀번호 재입력 */}
                            {pwStep >= 2 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>비밀번호 재입력</span>
                                    <div className={ style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input
                                                name="rePswd"
                                                type={rePwView ? "text" : "password"}
                                                placeholder='비밀번호를 입력해주세요'
                                                value={rePassword}
                                                onChange={handleRePasswordChange}
                                            />
                                            <span className={style['line']} data-discord={rePwLineStatus}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={rePwView ? "on" : "off"} onClick={handleRePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>
                                    <div className={style['input-bottom-box']}>

                                        {password && rePassword && password === rePassword ? (
                                            <span className={style['on']}>
                                            비밀번호가 일치합니다
                                        </span>
                                        ): (
                                            <span className={style['error']}>비밀번호가 일치하지 않습니다</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            )}

                            {/* 비밀번호  */}
                            {pwStep >= 1 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>비밀번호</span>
                                    <div className={style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input
                                                name="pswd"
                                                type={pwView ? "text" : "password"}
                                                placeholder='비밀번호를 입력해주세요'
                                                value={password}
                                                onChange={handleOnChangeInput}
                                            />
                                            <span className={style['line']} data-discord={pwLineStatus}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={pwView ? "on" : "off"} onClick={handlePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>
                                    <div className={style['input-bottom-box']}>
                                        <span className={style[pwRules.lengthAt ? 'on' : 'off']}>9자리 이상</span>
                                        <span className={style[pwRules.letterAt ? 'on' : 'off']}>영문</span>
                                        {/* <span className={style[pwRules.letterUpperAt ? 'on' : 'off']}>영문대문자</span> */}
                                        <span className={style[pwRules.numberAt ? 'on' : 'off']}>숫자</span>
                                        <span className={style[pwRules.specialAt ? 'on' : 'off']}>특수문자</span>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                        )}
                        {/* 새 비밀번호 입력 화면:: E */}



                        {/* 하단 다음 버튼 영역 :: S */}
                        <div className="bottom-fixed-box">
                            <div className="inner-box">
                                <div className="btn-layout" data-btn-num="1">
                                     {step < 6 && (
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handleNext}
                                        disabled={
                                            step === 1 ? !(userId.length > 0) :
                                            step === 2 ? !(name.length > 0) :
                                            true // 그 외 step에서는 기본적으로 비활성
                                        }

                                    >
                                        {/* console.log('pwStep ' + pwStep )*/}
                                        <span>{step === 4 ? '인증번호 요청'
                                                : step < 5
                                                ? '다음'
                                                : '인증번호 확인'}
                                        </span>
                                    </button>
                                    )}

                                    {step === 6 && (
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handlePw}
                                        disabled ={
                                            pwStep === 1 ? !( Object.values(pwRules).every(Boolean)) :
                                            pwStep === 2 ? !( Object.values(pwRules).every(Boolean) && password === rePassword && rePassword.length >= 9) : true
                                        }
                                    >
                                        <span>{pwStep === 2 ? '확인': '다음'}</span>
                                    </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* 하단 다음 버튼 영역 :: E */}

                        {/* 토스트 */}
                        {toast && (
                            <ToastPopup
                                setToast={setToast}
                                message={toastMessage}
                                position="center"
                                opacity="90"
                            />
                        )}

                        {/* 통신사 바텀시트 */}
                        <BottomSheet

                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지

                            open={open}
                            onDismiss={onDismiss}
                            snapPoints={({ minHeight }) => minHeight}
                            blocking={true}
                        >
                            <MobileTelecom
                                onClose={onDismiss}
                                onSelect={onTelecomSelect}
                            />
                        </BottomSheet>


                    </div>
                </div>
        </>
    )
}

export default FindPassword
